// extracted by mini-css-extract-plugin
export var cookieButton = "PageNewsPost-module--cookieButton--qva5B";
export var image = "PageNewsPost-module--image--wRqcm";
export var imageWrapper = "PageNewsPost-module--imageWrapper--CN5Ew";
export var label = "PageNewsPost-module--label--nZmUl";
export var preamble = "PageNewsPost-module--preamble--dT5Gb";
export var title = "PageNewsPost-module--title--tyUZq";
export var wrapper = "PageNewsPost-module--wrapper--XrMKv";